"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _RadioButton = require("../../components/RadioButtonGroup/RadioButton");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var RadioButton = {
  styles: function styles(theme) {
    return {
      root: {
        color: theme.colors.baseContrast085
      },
      rootDisabled: {
        color: theme.colors.baseContrast040
      },
      input: {
        "&:checked + div": {
          backgroundColor: _RadioButton.radioButtonVars.get("checkedInputColor", theme.colors.primary),
          "&:before": {
            backgroundColor: theme.colors.themeBase
          }
        },
        "&:checked:disabled + div": {
          borderColor: theme.colors.baseContrast040,
          backgroundColor: theme.colors.baseContrast040,
          "&:before": {
            backgroundColor: theme.colors.baseContrast020
          }
        }
      },
      check: {
        border: "1px solid ".concat(theme.colors.baseContrast060),
        background: theme.colors.themeBase
      },
      disabled: {
        border: "1px solid ".concat(theme.colors.baseContrast040),
        background: theme.colors.baseContrast010
      },
      hint: {
        marginInlineStart: theme.spacing.base / 2,
        textTransform: "initial",
        color: theme.colors.baseContrast085
      },
      description: {
        textTransform: "initial",
        color: theme.colors.baseContrast085
      }
    };
  }
};
var _default = exports.default = RadioButton;